import React from 'react';

const LoadingIndicator = ({message = "Loading..."}) => {
    return (
        <div className="c-event-registration-form__loading">
        <div className="c-event-registration-form__loading-spinner">
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <h5>{message}</h5>
      </div>
    )
}

export default LoadingIndicator;